export default __webpack_public_path__ + "static/media/icon-cart-full.1dbebf83.svg";